import { render, staticRenderFns } from "./SearchResultsCategory.vue?vue&type=template&id=03892d8e&scoped=true&"
import script from "./SearchResultsCategory.vue?vue&type=script&lang=js&"
export * from "./SearchResultsCategory.vue?vue&type=script&lang=js&"
import style0 from "./SearchResultsCategory.vue?vue&type=style&index=0&id=03892d8e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03892d8e",
  null
  
)

export default component.exports